import { DOAbnormalItemFileBase64Bean } from "./do-abnormal-item-file-base64-bean";
import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";
export class DOAbnormalCreateAbnormalItemRequest extends DOAbnormalOperationUserBean {
  doNo: string;
  moNo: string;
  abnormalQty: number | null;
  waitingReference: string | null;
  waitingReferenceDesc: string | null;
  relatedDetailSeqNos: number[] | null;
  relatedDetailExternLineNos: (string | null)[];
  relatedDetailSkus: (string | null)[];
  newFiles: DOAbnormalItemFileBase64Bean[] | null;

  constructor() {
    super();
    this.doNo = "";
    this.moNo = "";
    this.abnormalQty = null;
    this.waitingReference = null;
    this.waitingReferenceDesc = null;
    this.relatedDetailSeqNos = [];
    this.relatedDetailExternLineNos = [];
    this.relatedDetailSkus = [];
    this.newFiles = null;
  }
}
